export default __webpack_public_path__ + "static/media/responsive-giftWelcome-bg.616ecef1.webp";